export default "__VITE_ASSET__DIxzBw6y__"